import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  image: {
    width: 300,
    height: 100,
  },
});
